import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

import { useCmsApiPageSubsite } from './useCmsApiPageSubsite';

type Props = {
  cmsApiPage: CmsApiPage;
};

export function useCmsApiPageHomePageMeta({ cmsApiPage }: Props) {
  const subsite = useCmsApiPageSubsite({ cmsApiPage });
  const hasHomePage = Boolean(cmsApiPage.subsite.homePage);
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const subsiteHasHomePage = hasHomePage || Boolean(subsite.homePage);
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const homePageUrl = subsite.homePage ? subsite.homePage.url : '';

  return { hasHomePage, subsiteHasHomePage, homePageUrl };
}
